import { render, staticRenderFns } from "./password-sent.vue?vue&type=template&id=e826dc7a&scoped=true"
import script from "./password-sent.vue?vue&type=script&lang=js"
export * from "./password-sent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e826dc7a",
  null
  
)

export default component.exports